import SearchScanner from './SearchScanner.container';

export default SearchScanner;
